import bg_home from 'assets/images/bg_home.png';
import HeaderMenu from 'components/Header/HeaderMenu';
import HistoryPredictions from 'components/HistoryPredictions';
import { SITE } from 'config/config';
import { App, Spin } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { claimWorldCupReward, getFP, getIP, getWorldCupHistoryPredictionsAccount } from 'service/base';
import { twMerge } from 'tailwind-merge';

const HistoryPage = () => {
  const { notification } = App.useApp();
  const [activeHistoryTab, setActiveHistoryTab] = useState('score');
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');
  const [historyWcRows, setHistoryWcRows] = useState([]);
  const [isLoadingHistoryWc, setIsLoadingHistoryWc] = useState(false);
  const [claimingId, setClaimingId] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [ipRes, fpRes] = await Promise.all([getIP(), getFP()]);
        if (!mounted) return;
        setIP(ipRes);
        setFP(fpRes);
      } catch {
        // giữ rỗng; tab tỷ số vẫn báo khi submit
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const tabs = [
    { key: 'score', label: 'Dự đoán tỷ số' },
    { key: 'worldcup', label: 'Dự đoán World Cup' }
  ];

  const fetchHistoryWc = async (accountValue) => {
    const account = String(accountValue || '').trim();
    if (!account) {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng nhập tài khoản để xem lịch sử.'
      });
      return;
    }
    setIsLoadingHistoryWc(true);
    try {
      const res = await getWorldCupHistoryPredictionsAccount({
        account,
        site: SITE,
        ip: IP?.ip ?? IP,
        fp: FP?.fp ?? FP
      });
      const rows = Array.isArray(res?.data) ? res.data : [];
      setHistoryWcRows(rows);
      if (!rows.length) {
        notification.info({
          message: 'Thông báo',
          description: 'Không có dữ liệu lịch sử.'
        });
      }
    } catch (e) {
      notification.error({
        message: 'Lỗi',
        description: e?.message || 'Không tải được lịch sử dự đoán.'
      });
    } finally {
      setIsLoadingHistoryWc(false);
    }
  };

  useEffect(() => {
    if (activeHistoryTab !== 'worldcup') return;
    const savedAccount =
      localStorage.getItem('userAccount') ||
      localStorage.getItem('hi88_login_username') ||
      localStorage.getItem('saved_account') ||
      '';
    if (!savedAccount) return;
    fetchHistoryWc(savedAccount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeHistoryTab, IP, FP]);

  return (
    <div className={twMerge(SITE, 'w-full min-h-full')}>
      <img
        src={bg_home}
        alt=""
        className="fixed bottom-0 right-0 h-full w-full object-cover"
      />
      <div className="hidden xl:block">
        <div className="fixed left-0 top-4">
          <img
            src="assets/images/match/terry1.png"
            alt=""
            className="h-auto w-80 object-contain"
          />
        </div>
        <div className="fixed bottom-0 right-0">
          <img
            src="assets/images/match/terry2.png"
            alt=""
            className="h-auto w-60 object-contain"
          />
        </div>
      </div>
      <div className="relative z-10 pb-6">
        <HeaderMenu />
        <div className="container relative z-10 px-2 md:px-4">
          <div
            className="mx-auto mt-2 w-full max-w-[1200px] rounded-3xl border-[6px] border-solid border-[#26A9E0] bg-white/95 p-3 shadow shadow-primary md:p-6 md:pb-8"
            style={{ background: 'rgba(255,255,255,0.95)' }}
          >
            <h1 className="mb-3 text-center text-lg font-bold text-[#0f172a] md:text-xl">
              Lịch sử dự đoán
            </h1>
            <div className="mb-4 flex flex-wrap items-center justify-center gap-2 md:gap-3">
              {tabs.map((tab) => {
                const isActive = activeHistoryTab === tab.key;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    onClick={() => setActiveHistoryTab(tab.key)}
                    className={twMerge(
                      'rounded-full border px-4 py-2 text-[13px] font-bold transition-colors md:text-[14px]',
                      isActive
                        ? 'border-[#26A9E0] bg-[#26A9E0] text-white'
                        : 'border-[#d6dbe3] bg-white text-[#334155] hover:border-[#26A9E0]'
                    )}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>

            {activeHistoryTab === 'score' ? (
              <HistoryPredictions embedded IP={IP} FP={FP} />
            ) : (
              <div className="px-0 md:px-1">
                {isLoadingHistoryWc ? (
                  <div className="py-10 text-center">
                    <Spin />
                  </div>
                ) : (
                  <div className="overflow-x-auto rounded-[10px] border border-[#d5d9df]">
                    <table className="w-full min-w-[860px] border-collapse">
                      <thead>
                        <tr className="bg-[#26A9E0] text-white">
                          <th className="border border-[#7ec8e8] px-3 py-3 text-center text-[14px] font-bold">
                            Thời gian
                          </th>
                          <th className="border border-[#7ec8e8] px-3 py-3 text-center text-[14px] font-bold">
                            Dự đoán
                          </th>
                          <th className="border border-[#7ec8e8] px-3 py-3 text-center text-[14px] font-bold">
                            Bạn dự đoán
                          </th>
                          <th className="border border-[#7ec8e8] px-3 py-3 text-center text-[14px] font-bold">
                            Kết quả
                          </th>
                          <th className="border border-[#7ec8e8] px-3 py-3 text-center text-[14px] font-bold">
                            Nhận thưởng
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {historyWcRows.length ? (
                          historyWcRows.map((row, idx) => {
                            const normalizedResult =
                              typeof row?.result === 'string' ? row.result.trim().toLowerCase() : row?.result;
                            const isWon =
                              normalizedResult === true ||
                              normalizedResult === 1 ||
                              normalizedResult === '1' ||
                              normalizedResult === 'true' ||
                              normalizedResult === 'win' ||
                              normalizedResult === 'correct';
                            const numericPoint = Number(row?.point) || 0;
                            const pointDisplay =
                              isWon && numericPoint > 0 ? Intl.NumberFormat('vi-VN').format(numericPoint) : '-';

                            const normalizedRewardStatus =
                              typeof row?.status_register === 'string'
                                ? row.status_register.trim().toLowerCase()
                                : row?.status_register;
                            const isAccepted =
                              normalizedRewardStatus === 'accept' ||
                              normalizedRewardStatus === true ||
                              normalizedRewardStatus === 1 ||
                              normalizedRewardStatus === '1';
                            const isApply = normalizedRewardStatus === 'apply';
                            const canClaim =
                              isWon && isApply && Boolean(row?.id) && Boolean(row?.predictType);
                            const rowKey = `${row?.id || row?.type || 'row'}-${row?.name || ''}-${idx}`;
                            const isClaiming = claimingId === rowKey;

                            return (
                            <tr key={rowKey}>
                              <td className="border border-[#d6dbe3] px-3 py-3 text-center text-[14px] text-[#374151]">
                                {row?.createdAt ? dayjs(row.createdAt).format('DD/MM/YYYY') : '-'}
                              </td>
                              <td className="border border-[#d6dbe3] px-3 py-3 text-center text-[14px] text-[#374151]">
                                {row?.type || '-'}
                              </td>
                              <td className="border border-[#d6dbe3] px-3 py-3 text-center text-[14px] font-semibold text-[#26A9E0]">
                                {row?.name || '-'}
                              </td>
                              <td className="border border-[#d6dbe3] px-3 py-3 text-center text-[14px] text-[#2f5ca8]">
                                {pointDisplay}
                              </td>
                              <td className="border border-[#d6dbe3] px-3 py-3 text-center text-[14px]">
                                <button
                                  type="button"
                                  disabled={!canClaim || isClaiming}
                                  onClick={async () => {
                                    if (!canClaim || isClaiming) return;
                                    try {
                                      setClaimingId(rowKey);
                                      const payload = {
                                        id: row.id,
                                        account: row.account || '',
                                        predictType: row.predictType
                                      };
                                      const res = await claimWorldCupReward(payload);
                                      if (res?.code === 0) {
                                        notification.success({
                                          message: 'Thành công',
                                          description: res?.message || 'Nhận thưởng thành công.'
                                        });
                                        setHistoryWcRows((prev) =>
                                          (Array.isArray(prev) ? prev : []).map((item) =>
                                            `${item?.id ?? ''}` === `${row.id ?? ''}`
                                              ? { ...item, status_register: 'accept' }
                                              : item
                                          )
                                        );
                                        return;
                                      }
                                      notification.error({
                                        message: 'Lỗi',
                                        description: res?.message || 'Nhận thưởng thất bại.'
                                      });
                                    } catch (error) {
                                      notification.error({
                                        message: 'Lỗi',
                                        description: error?.message || 'Nhận thưởng thất bại.'
                                      });
                                    } finally {
                                      setClaimingId('');
                                    }
                                  }}
                                  className={`mx-auto block h-[30px] md:h-[34px] w-full max-w-[96px] md:max-w-[112px] rounded-[10px] px-2 text-[10px] md:text-[13px] font-semibold leading-[30px] md:leading-[34px] text-white border-0 ${
                                    canClaim
                                      ? 'cursor-pointer bg-gradient-to-b from-[#00CD32] to-[#048724]'
                                      : 'cursor-not-allowed bg-[#9ea3a7]'
                                  }`}
                                >
                                  {isClaiming ? 'Đang nhận...' : isAccepted ? 'Đã nhận thưởng' : 'Nhận thưởng'}
                                </button>
                              </td>
                            </tr>
                          );
                          })
                        ) : (
                          <tr>
                            <td
                              colSpan={5}
                              className="border border-[#d6dbe3] px-3 py-8 text-center text-[14px] text-[#6b7280]"
                            >
                              Chưa có dữ liệu lịch sử.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryPage;
